import { useTranslation } from 'react-i18next';
import useHttpPM from '../../../../../../hooks/use-httpPM';
import DragAndDrop from '../../../../../UI/DragAndDrop';
import TextArea from '../../../../../UI/FormControls/TextArea';
import OAutocomplete from '../../../../../UI/MuiAutocomplete';

const config = { url: 'PlaniranjeProizvodnje/vrati_vrste_dokumenata' };

const NoviFajl = ({ setFile, file, formData, setFormData }) => {
  const { t } = useTranslation();
  const { data: comboData } = useHttpPM(config);

  const handleFiles = (files) => {
    setFile(files);
  };

  const handleUkloniFile = (fileToRemove) => {
    setFile((prev) =>
      prev.filter(
        (f) =>
          !(
            f.name === fileToRemove.name &&
            f.lastModified === fileToRemove.lastModified
          ),
      ),
    );
  };

  const handleClick = (e) => {
    setFormData((curr) => {
      return { ...curr, idVrsteDokOpste: e.id, nazivVrsteDokOpste: e.vrednost };
    });
  };

  const handleChange = (e) => {
    setFormData((curr) => {
      return { ...curr, [e.target.name]: e.target.value };
    });
  };

  return (
    <div style={{ marginBottom: '120px' }}>
      <div>
        <OAutocomplete
          label={t('projectProgress.documentTypeRequired')}
          data={comboData}
          value={formData.nazivVrsteDokOpste}
          handleClick={(e) => handleClick(e)}
          touched={formData.touchedVrsta}
          setTouched={() => {
            setFormData((curr) => {
              return { ...curr, touchedVrsta: true };
            });
          }}
          style={{ width: '300px' }}
          errorMessage={t('projectProgress.documentTypeRequiredError')}
        />
      </div>
      <div style={{ marginTop: '10px' }}>
        <TextArea
          label={t('description')}
          rows="4"
          name="opis"
          value={formData.opis}
          handleChange={handleChange}
          style={{ width: '99%', height: '60px' }}
        />
      </div>
      <div style={{ marginTop: '10px' }}>
        <DragAndDrop
          handleFiles={handleFiles}
          maxFiles={5}
          addedFiles={file}
          handleRemoveFile={handleUkloniFile}
        />
      </div>
    </div>
  );
};

export default NoviFajl;
